import React, { useState, useEffect } from "react";
import {
  getTransactionTableEntityType,
  getTransactionType,
  getTxnState,
  getWithdrawTransactionStatus,
} from "../recentActivityHelper";
import {
  END_OF_RESPONSE,
  TRANSACTION_TABLE_ENTITY_TYPE_MAP,
  VIEW_ENTITY_TYPE,
} from "../../../services/RecentActivity/recentTransactions/recentTransaction.constants";
import {
  formatMoney,
  formatTime,
} from "../../../utils/helperFunctions";
import TransactionItem from "./transactionItem";
import parse from "html-react-parser";
import { chevronRight } from "../../../assets/images/icons";
import {
  getMobileOperatingSystem,
  ingestData,
  isMobile,
  navigateToURL,
} from "../../../bridges/BridgeServices";
import useIntersectionObserver from "../../../hooks/useIntersectionObserver";
import Spinner from "../../Spinner/spinner";
import { useStore } from "../../../store/useStore";
import { getPlatformForBot } from "../../Chatbot/ChatbotUtil";
import {
  CHATBOT_SOURCE,
  EVENTS,
  RECENT_ACTIVITY_TYPES,
} from "../../../utils/constants";
import FullPagePopover from "../../FullPagePopover/FullPagePopover";

const Transactions = ({ refetchData }) => {
  const [showTranSheet, setShowTranSheet] = useState(false);
  const transactions = Object.values(
    useStore(state => state.transactions)
  ).sort((a, b) => b.createdAt - a.createdAt);

  const [items, setItems] = useState(transactions);
  const nextPageToken = useStore(
    state => state.transactionsNextPageToken
  );
  const loading = useStore(
    state => state.transactionLoading
  );

  const targetRef = useIntersectionObserver(
    () => {
      if (nextPageToken !== END_OF_RESPONSE) {
        refetchData();
      }
    },
    { threshold: 0.1 }
  );

  useEffect(() => {
    if (showTranSheet) {
      ingestData({
        name: EVENTS.HELP_ACTIVITY_POPUP_LOADED,
        data: {
          source: isMobile()
            ? getMobileOperatingSystem()
            : "WEB",
          type: RECENT_ACTIVITY_TYPES.FUNDS,
        },
      });
    }
  }, [showTranSheet]);

  if (transactions.length === 0) return <></>;

  const handleTransactionClick = item => {
    ingestData({
      name: EVENTS.HELP_ACTIVITY_CLICKED,
      data: {
        source: isMobile()
          ? getMobileOperatingSystem()
          : "WEB",
        type: RECENT_ACTIVITY_TYPES.FUNDS,
        txnId: item?.data?.globalTransactionId,
      },
    });
    if (item.data?.globalTransactionId && item.state) {
      navigateToURL("CHATBOT", {
        src: getTransactionType(item),
        txnId: item.data?.globalTransactionId,
        txnState: getTxnState(item.state),
        errorCode: item.data?.responseCode,
        platform: getPlatformForBot(),
      });
    }
  };

  return (
    <div>
      <p className="transactionComponent">Transactions</p>

      <div>
        {transactions?.slice(0, 2).map((item, index) => {
          const transactionStatus = getWithdrawTransactionStatus(
            item.view.find(
              view =>
                view.type !== VIEW_ENTITY_TYPE.SENT_PAYMENT
            ) || item[0]
          );
          const viewData = item.view.find(
            view =>
              view.type !== VIEW_ENTITY_TYPE.SENT_PAYMENT
          );
          return (
            <div
              key={index}
              className="lineItem"
              onClick={() =>
                handleTransactionClick(viewData)
              }
            >
              <div className="leftLineItem">
                <div className="typeContainer">
                  <p className="entityType">
                    {
                      TRANSACTION_TABLE_ENTITY_TYPE_MAP[
                        getTransactionTableEntityType(
                          viewData
                        )
                      ]
                    }
                  </p>
                  <p className="inactiveText">
                    {formatMoney(
                      viewData.data.amount ||
                        viewData?.data?.actualAmount ||
                        viewData?.data?.requestedAmount
                    )}
                  </p>
                </div>
                <div className="statusContainer">
                  <p
                    className={`paymentState ${transactionStatus}`}
                  >
                    {transactionStatus}
                  </p>
                  <p className="inactiveText">
                    {formatTime(item?.updated)}
                  </p>
                </div>
              </div>
              <div>{parse(chevronRight)}</div>
            </div>
          );
        })}
      </div>
      <button
        className="actionButton"
        onClick={() => {
          ingestData({
            name: EVENTS.HELP_ACTIVITY_CTA_CLICKED,
            data: {
              source: isMobile()
                ? getMobileOperatingSystem()
                : "WEB",
              type: RECENT_ACTIVITY_TYPES.FUNDS,
            },
          });
          setShowTranSheet(true);
        }}
      >
        View More Transactions
      </button>

      <FullPagePopover
        setIsOpen={setShowTranSheet}
        isOpen={showTranSheet}
        title={`Select Transactions`}
        wrapperClassname={"transactionSheet"}
      >
        {transactions.map((item, index) => {
          return (
            <TransactionItem
              key={index}
              item={item}
              onTransactionClick={() => {
                ingestData({
                  name: EVENTS.HELP_ACTIVITY_CLICKED,
                  data: {
                    source: isMobile()
                      ? getMobileOperatingSystem()
                      : "WEB",
                    type: RECENT_ACTIVITY_TYPES.FUNDS,
                    txnId: item?.data?.globalTransactionId,
                  },
                });
                setShowTranSheet(false);
              }}
            />
          );
        })}
        {loading ? (
          <Spinner />
        ) : (
          <div
            ref={targetRef}
            style={{ padding: "4px", height: "10px" }}
          ></div>
        )}
      </FullPagePopover>
    </div>
  );
};

export default Transactions;
